import { Preview as PreviewModule } from '@modules/preview';
import styles from './preview.module.scss';

export const Preview = () => (
  <main className={styles.root}>
    <PreviewModule />
  </main>
);
